// 📄 resumenHorasService.ts
// Resumen de horas de TODOS los consultores de un proyecto, para el rol
// "cliente" (solo lectura). Va por onehubApi (nunca Firestore directo),
// porque el endpoint filtra tarifaHora/totalCalculado server-side — ver
// functions/routes/resumenHoras.js.
import { getAuth } from "firebase/auth";

import { EstadoAprobacion } from './registroHorasService.ts';

export interface RegistroHorasResumen {
  id: string;
  fecha: string | null;
  solucionRelacionada: string;
  horas: number;
  cambiosRealizados: string;
  creadoPor: string;
  estadoAprobacion: EstadoAprobacion;
  comentarioCliente: string;
  fechaRevisionCliente: string | null;
}

export const obtenerResumenHoras = async (projectId: string): Promise<RegistroHorasResumen[]> => {
  const user = getAuth().currentUser;
  if (!user) throw new Error("No se detectó una sesión activa. Por favor, reingresa al sistema.");
  const token = await user.getIdToken();

  const response = await fetch(`${process.env.REACT_APP_API_URL}/resumen-horas`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify({ projectId })
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || `Error ${response.status} al obtener el resumen de horas.`);
  }
  return data.registros;
};
